import React, { useState, useEffect } from 'react';
import { Link, useNavigate } from 'react-router-dom';

import AxiosApiClient from '../../components/utils/AxiosApiClient';
import AuthUtility from '../frontend/auth/AuthUtility';
import LoadingSpinner from '../frontend/LoadingSpinner';

import swal from 'sweetalert';

import edit_icon from '../../assets/frontend/images/edit_icon.png';

function Subscriptions() {

	const navHistory = useNavigate();

	//for all API calls
	const auth_api = 'phpLaravel';
	if (localStorage.getItem('auth_api') && localStorage.getItem('auth_api') !== '') {
		auth_api = localStorage.getItem('auth_api');
	}

	// using hooks
	const [isLoading, setIsLoading] = useState(false);
	const [isMounted, setIsMounted] = useState(false);

	// Initial call for user list items
	useEffect(() => {

		if (!AuthUtility.isLoggedIn()) {
			//user not authenticated on server so remove from local storage
			AuthUtility.clearAuthData()
			navHistory('/login');
		}

		if (isMounted) {
			console.log('[Account - useEffect] mounted');
		} else {
			setIsMounted(true);
		}

	}, [isMounted]);

	const loadPlans = (event) => {
		event.preventDefault();

		setIsLoading(true);

		const fetchApiData = async () => {
			try {
				const { apiClient, getBearerToken, makeRequestWithHeaders } = AxiosApiClient({ apiBackend: auth_api, token: localStorage.getItem('auth_token') });
				await getBearerToken();
				const response = await makeRequestWithHeaders('get', '/api/subscriptions', null, {});

				setApiData(response, "loadPlans");
			} catch (error) {
				handleApiError(error, "loadPlans");
			}
		};

		fetchApiData();
	}
	function setApiData(response, theFunction) {
		if (response && response.data) {
			if (response.data.status === 200) {//HTTP_OK
				console.log(theFunction + ': ', response.data.message);

				//user not authenticated on server so remove from local storage
				AuthUtility.clearAuthData();
				navHistory('/');
			} else if (response.data.status === 401) {//HTTP_UNAUTHORIZED
				console.log(theFunction + ' error: ', response.data.message + ' back-end api call error');

				//user not authenticated on server so remove from local storage
				AuthUtility.clearAuthData();
				swal("Warning", response.data.message, "warning");
				navHistory('/login');
			} else {//more errors
			}
		}

		setIsLoading(false);
	}
	function handleApiError(error, theFunction) {
		console.log(theFunction + ' error: ', error + ' back-end api call error');

		//user not authenticated on server so remove from local storage
		AuthUtility.clearAuthData();
		setIsLoading(false);
		swal("Error", error, "error");
		navHistory('/login');
	}

	return (
		<div className="body-content bg-fff pt-70l-110m-60s pb-40">
		
			<div className="panel large pt-20l-10s">
				<div className="grid-x">
					<div className="large-12 medium-12 small-12 cell text-left">
						<div className="font-orbitron font-size-24 font-weight-800 bb1-555 uppercase italic pb-5">Subscriptions</div>
					</div>
					{isLoading &&
					<div className="large-12 medium-12 small-12 cell text-center pt-20">
						<LoadingSpinner paddingclassName="none" sizeclassName="none" />
					</div>
					}
				</div>
			</div>

			<div className="panel large pt-20l-10s">
				<div className="grid-x b1-ccc p-20l-10s">

					<div className="large-12 medium-12 small-12 cell text-left">
						<table className="striped unbordered mb-0">
							<tbody>
								<tr><td className="font-source-sans font-size-16l-14s font-weight-400 width-100px pb-20">Name:</td><td className="font-source-sans font-size-16l-14s font-weight-600 pb-20">{localStorage.getItem('auth_first_name') + ' ' + localStorage.getItem('auth_last_name')}</td></tr>
								<tr><td className="font-source-sans font-size-16l-14s font-weight-400 width-100px pb-20">Email:</td><td className="font-source-sans font-size-16l-14s font-weight-600 pb-20">{localStorage.getItem('auth_email')}</td></tr>
								<tr><td className="font-source-sans font-size-16l-14s font-weight-400 width-100px pb-20">Role:</td><td className="font-source-sans font-size-16l-14s font-weight-600 pb-20">{localStorage.getItem('auth_role')}</td></tr>
								<tr><td className="font-source-sans font-size-16l-14s font-weight-400 width-100px pb-20">Password:</td><td className="font-source-sans font-size-16l-14s font-weight-600 pb-20">********</td></tr>
								<tr><td className="font-source-sans font-size-16l-14s font-weight-400 width-100px">Paypal Email:</td><td className="font-source-sans font-size-16l-14s font-weight-600">{localStorage.getItem('auth_paypal_email')}</td></tr>
							</tbody>
						</table>
					</div>

				</div>
			</div>

		</div>
	);
}

export default Subscriptions;